/** Decode JWT payload exp without verification (client-side expiry hint only). */
export const isJwtExpired = (token: string, skewMs = 0): boolean => {
  try {
    const [, payload] = token.split('.');
    if (!payload) return true;
    const exp = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/'))).exp;
    return typeof exp === 'number' && Date.now() > exp * 1000 + skewMs;
  } catch {
    return true;
  }
};

/** Grace after nominal expiry before treating access JWT as stale on hydrate. */
export const JWT_HYDRATE_EXPIRY_SKEW_MS = 60_000;
